import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const Layout = ({ children, darkMode = false }) => {
  return (
    <div className={darkMode ? "bg-[#0A0E17] text-white" : "bg-[#F9F9F7] text-[#1C1C1C]"}>
      <Header darkMode={darkMode} />
      <main className="pt-20">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
